import { getHotplay } from '@/util/hotplaygames'
export default {
    data () {
        return {
            version:'',
            size:'',
            url: '',
            downimg: 'https://cdn.hotplaydl.com/static/img/down.png'
        };
    },
    methods: {
        down() {
            this.$router.push({
                path:'/loadpage',
                query: {
                    version: this.version,
                    size: this.size
                }
            })
        },
    },
    async created() {
        let {data: res} = await getHotplay()
        this.version = res.vername
        this.size = ((( res.size )/1024)/1024).toFixed(2)
        this.url = res.url
    }
}


// WEBPACK FOOTER //
// ./src/mixins/downMixin.js